import React, { useEffect, useRef } from "react";
import { CustomToolbarItemModel, DocumentEditor, DocumentEditorContainerComponent, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { saveEditDocument } from "../../../redux/EngageTranslation/EngageTranslationAction";
import "./DocumentEditorViewer.css";
import { current } from "@reduxjs/toolkit";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
DocumentEditorContainerComponent.Inject(Toolbar);

function DocumentEditorViewer(props: any) {
  const saveLoading = useSelector((state: RootState) => state.engageTranslationState.engageTranslationDetailPageState.loadingSave);

  let toolItem: CustomToolbarItemModel = {
    prefixIcon: "e-save",
    tooltipText: "Save Document",
    text: "Save",
    id: "Save",
  };
  const dispatch = useAppDispatch();
  const container = useRef(null) as any;
  const save = async () => {
    const documentContent = await container.current.documentEditor.saveAsBlob("Sfdt");

    //try to download the file
    // let formData: FormData = new FormData();
    // formData.append('documentName', container.documentEditor.documentName);
    // formData.append('data', documentContent);

    await dispatch(saveEditDocument({ selectedRecordID: props.selectedDocumentID, file: documentContent }));
  };
  const renderComplete = async () => {
    window.onbeforeunload = function () {
      return "Want to save your changes?";
    };
    container.current.documentEditor.resize();
    container.current.documentEditor.acceptTab = true;
    container.current.toolbarClick = (args: any) => {
      if (args.item.id === "Save") {
        save();
      }
    };
    container.current.documentEditor.open(props.document);

    // onLoadDefault();
  };

  useEffect(() => {
    if (container.current) {
      renderComplete();
    }
    const docEditor = container.current as DocumentEditorContainerComponent;
  }, []);
  return (
    <div className="document-container">
      <DocumentEditorContainerComponent
        // created={() => onCreated()}
        // id="container"
        ref={container}
        style={{ display: "block", position: "relative" }}
        height="100%"
        enableToolbar={true}
        serviceUrl="https://services.syncfusion.com/react/production/api/documenteditor/"
        locale="en-US"
        enableLocalPaste={true}
        restrictEditing={!props.editable}
        readOnly={!props.editable}
        toolbarItems={props.editable ? [toolItem, "Undo", "Redo", "Separator", "Image", "Table", "Hyperlink", "Bookmark", "Comments", "TableOfContents", "Separator", "Header", "Footer", "PageSetup", "PageNumber", "Break", "Separator", "Find", "Separator", "LocalClipboard", "RestrictEditing"] : ["Find"]}
      />
      {props.editable && saveLoading && (
        <div
          id="spinner"
          style={{ position: "absolute", top: 0, width: "100%", height: "100%", backgroundColor: "#8080807a", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Spin
            size="large"
            tip="Loading..."
          />
        </div>
      )}
    </div>
  );
}

export default DocumentEditorViewer;
